import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import AdminManagement from '@views/Admin/Management';

const messages = defineMessages({
  title: {
    id: 'admin.users.title',
    defaultMessage: 'Manage Users',
  },
});

function AdminUsersPage() {
  const { formatMessage } = useIntl();

  return (
    <AdminManagement.Layout title={formatMessage(messages.title)}>
      <AdminManagement.Users.List />
    </AdminManagement.Layout>
  );
}

export default AdminUsersPage;
